import { Configure, ConfigureProps } from 'react-instantsearch';

export default function ConfigureFix(
  props: ConfigureProps & { hitsPerPage: number }
) {
  return <Configure {...props} />;
}
